import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GoogleOauthService {
  constructor(private http: HttpClient) {
    // BUSCAR INFORMACION PARA EL USUARIO
    // this.googleOauthService
    //   .getUserInfo(tokenResponse.access_token)
    //   .subscribe((responses: any) => {
    //     console.log(responses);
    //   });
  }

  getUserInfo(accessToken: string): Observable<any> {
    return this.http
      .get('https://www.googleapis.com/oauth2/v1/userinfo', {
        headers: new HttpHeaders({ Authorization: 'Bearer ' + accessToken }),
      })
      .pipe();
  }
}
